module.exports = __webpack_public_path__ + "img/CloudGuard-Service.ed527b2.svg";